<template>
    <div
        class="icon"
        :style="`width: ${size}px; height: ${size}px;`"
        v-html="require(`@/assets/img/icons/${name}.svg`)"
    ></div>
</template>

<script>
export default {
    name: 'Icon',
    props: {
        name: {
            type: String,
            default: 'party-confetti',
            required: true,
        },
        size: {
            type: [Number, String],
            default: 24,
        },
    },
}
</script>

<style scoped lang="sass">
.icon
    display: inline-flex
    justify-content: center
    align-items: center

    &::v-deep
        svg
            width: 100% !important
            height: 100% !important
            stroke-width: 1.5px
</style>
